import { Component, inject, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { CodaltComponent } from '../../codalt.component';
import { ApiService } from '../../services/api/api.service';

interface AuthSession {
    id: number;
    uuid: string;
    type: string;
    session_type: 'regular' | 'impersonation' | 'temporary';
    device_type: string;
    device_name: string | null;
    latest_location: string | null;
    latest_municipality: string | null;
    created_at: string;
    last_activity_at: string | null;
    expires_at: string | null;
    revoked_at: string | null;
    impersonated_by: { id: number; name: string } | null;
    is_current: boolean;
}

/**
 * Sessions of the logged in user.
 */
@Component({
    selector: 'app-auth-sessions',
    standalone: false,
    templateUrl: './auth-sessions.component.html',
})
export class AuthSessionsComponent extends CodaltComponent implements OnInit {
    private apiService = inject(ApiService);

    loading = true;
    sessions: AuthSession[] = [];

    ngOnInit() {
        this.subscriptions.add(
            this.apiService
                .getCallData$<AuthSession[]>('auth/me/sessions')
                .pipe(finalize(() => (this.loading = false)))
                .subscribe(sessions => (this.sessions = sessions))
        );
    }

    status(session: AuthSession): 'Actief' | 'Ingetrokken' | 'Verlopen' {
        if (session.revoked_at) {
            return 'Ingetrokken';
        }
        return session.expires_at && new Date(session.expires_at) <= new Date() ? 'Verlopen' : 'Actief';
    }
}
